import React, {useEffect} from 'react';
import {ReactComponent as PlustIcon} from '../../../../../../assets/main/groups/online/plus.svg';
import {FilesList} from "./file-list/File-list";
import {useAppDispatch, useAppSelector} from "common/hook";
import {NavLink, useParams} from "react-router-dom";
import {ROLE_DEMO_STUDENT, ROLE_STUDENT} from "entities/constants/constants";
import {fetchHomeWork} from "features/model/service/groups/lessons/fetch-home-work/fetchHomeWork";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";

export const Homework = () => {
    const dispatch = useAppDispatch();
    const {groupId,lessonsId} = useParams();

    useEffect(() => {
        dispatch(fetchHomeWork(lessonsId));
    }, [dispatch, lessonsId]);

    const roleType = useAppSelector((state) => state.role.roleType);
    const homeWorkState = useAppSelector((state) => state.homeWork);


    const {data, error, isLoading} = homeWorkState;


    return (
        <>
            {roleType === ROLE_STUDENT &&
                <div style={{justifyContent: 'space-between'}} className="details-data-box">
                    <div className="col">
                        <p className="col-title">Дата домашнего задания</p>
                        {data.date}
                    </div>
                    <div className="col">
                        <p className="col-title">Занятие</p>
                        <p>{data.lessonTitle}</p>
                    </div>
                    <div className="col">
                        <p className="col-title">Статус</p>
                        {data.answer?.status === 'done' ? (
                            <p className="status-item">
                                <span>Выполнено</span>
                            </p>
                        ) : data.answer?.status === 'notDone' ? (
                            <p className="status-item not-done">
                                <span>Не выполнено</span>
                            </p>
                        ) : data.answer?.status === 'partiallyDone' ? (
                            <p className="status-item partially-done">
                                <span>Частично выполнено</span>
                            </p>
                        ) : data.answer?.status === 'notAssigned' ? (
                            <p className="status-item not-assigned">
                                <span>Не сдано</span>
                            </p>
                        ) : data.answer?.status === 'notVerified' ? (
                            <p className="status-item not-assigned">
                                <span>Не проверено</span>
                            </p>
                        ) : null}
                    </div>

                </div>
            }


            <div className="info-cards-box masonry-view">
                {isLoading ? (
                    <Preloader/>
                ) : data ? (
                    <>
                        <div className="info-card large">
                            <div className="info-card-hdr">
                                <div className="title-box">
                                    <p className="info-card-title h6">Описание домашнего задания</p>
                                </div>
                            </div>
                            <div className="info-card-content">
                                {data.description ? (
                                    <p>{data.description}</p>
                                ) : (
                                    <NothingYetMessage/>
                                )}
                            </div>
                        </div>
                        <div className="info-card full-width-mobile">
                            <div className="info-card-hdr">
                                <div className="title-box">
                                    <p className="info-card-title h6">Материалы домашнего задания</p>
                                </div>
                            </div>
                            <div className='info-card-content'>
                                {
                                    data.homeworkFiles ? (
                                        <FilesList files={data.homeworkFiles}/>
                                    ) : (
                                        <NothingYetMessage/>
                                    )
                                }
                            </div>
                        </div>
                        <hr/>

                        {(roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT) && (
                            <>
                                <div className="info-card large">
                                    <div className="info-card-hdr">
                                        <div className="title-box">
                                            <p className="info-card-title h6">Ответ студента</p>
                                        </div>
                                    </div>
                                    {data && data.answer?.status !== 'notAssigned' ? (
                                        <div className="info-card-content">
                                            {data.answer.text ?
                                                <p>{data.answer.text}</p> :
                                                <NothingYetMessage/>
                                            }
                                            <ul className="attached-files-list">
                                                {data.answer?.homeworkFiles?.map((attachment, index) => (
                                                    <li key={index}>
                                                        <div className="file-name">
                                                            <a href={attachment.path}>{attachment.fileName}</a>
                                                        </div>
                                                        <span className="file-size">{attachment.fileSize}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ) : (
                                        <div className="info-card-content">
                                            <NavLink
                                                className="btn has-icon"
                                                style={{maxWidth: '216px', display: 'inline-block'}}
                                                to={`/groups/${groupId}/lessons/${lessonsId}/student-response`}
                                            >
                                                 <span className="icon">
                                                    <PlustIcon/>
                                                 </span>
                                                <span>Добавить ответ</span>
                                            </NavLink>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <NothingYetMessage/>
                )}
            </div>
        </>
    );
};

